// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_kg-1";
export var rowFirst = "_kg-3";
export var rowLast = "_kg-5";
export var rowMiddle = "_kg-4";
export var ticketListScroll = "_kg-2";
export var ticketStack = "_kg-0";